import request from '@/axios'
import { getVersionConfig as getVersion } from '@/axios/preRequest'

// 获取配置字典
export const getConfigListApi = (data?: any) => {
  return request.post({
    url: '/report/common/config/list',
    data
    // baseURL
  })
}

// 获取版本配置
export const getVersionConfig = () => {
  return getVersion()
}

// 获取全部产品选项接口
export const getProductOpt = (data: object) => {
  return request.post({
    url: '/report/common/config/productLinkSearch',
    data
  })
}

// 获取全部组织选项接口
export const getOrganizationOpt = (data: object) => {
  return request.post({
    url: '/report/common/config/orgLinkSearch',
    data
  })
}

// 管理端组织选项接口
export const getManageOrganizationOpt = (data: object) => {
  return request.post({
    url: '/report/common/config/manageOrgLinkSearch',
    data
  })
}

// 行政区划级联查询
export const getAllDistrict = (data: object) => {
  return request.post({
    url: '/report/common/config/districtSearch',
    data
  })
}

// 行政区划-查询全部省份列表
export const getDistrictList = (data: object) => {
  return request.post({
    url: '/report/common/config/districtListSearch',
    data
  })
}

// 操作日志-报表查看上报
export const saveChartOpr = (data: object) => {
  return request.post({
    url: '/oprLog/saveChartOpr',
    data
  })
}

// 获取报表最新的更新时间
export const getReportTime = (code: string) => {
  return request.post({
    url: '/report/common/config/reportTime',
    data: {
      code
    }
  })
}

// 获取指标释义
export const getReportConfigRemark = (code: string) => {
  return request.post({
    url: '/report/common/config/remark',
    data: {
      code
    }
  })
}

// 获取用户导出记录列表
export const getExportRecord = (data: object) => {
  return request.post({
    url: '/commonExportRecord/list',
    data,
    hideLoading: true
  })
}

// 导出进度条查询-获取当前导出进度
export const getExportProgress = (data: object) => {
  return request.post({
    url: `/commonExportRecord/getExportProgress`,
    data,
    hideLoading: true
  })
}

// 获取导入模板
export const getImportTemplate = (data: object) => {
  return request.post({
    url: '/importTask/getImportTemplate',
    data
  })
}

// 获取导入记录
export const getImportRecord = (data: object) => {
  return request.post({
    url: '/importTask/list',
    data
  })
}

// 获取导入结果
export const getImportResult = (taskCode: string) => {
  return request.get({
    url: `/importTask/getImportProgress/${taskCode}`,
    hideLoading: true
  })
}

// 获取数据更新进度条
export const getProgressResult = (data: object) => {
  return request.post({
    url: '/importTask/getDataUpdateProgress',
    data,
    hideLoading: true
  })
}

// 获取组织人员列表
export const getBIOrgPersonListApi = (data?: any) => {
  return request.post({
    url: '/account/list',
    data
  })
}

// 获取配置字典
export const getOrgPersonListApi = (data?: any) => {
  return request.post({
    url: '/account/orgJurisdictionSearchEmployee',
    data
    // baseURL
  })
}

// 获取指标释义
export const getReportImportMonth = (data?: any) => {
  return request.post({
    url: '/report/common/config/performance',
    data
  })
}

// 流向数量合计(折算前)
export const getWeekFlowTrackTotal = (data?: any) => {
  return request.post({
    url: '/biz-adjust/week/weekFlowTrackTotal',
    data
  })
}

// 周流向数据处理 周任务完成调整-多组织 流向数量合计(折算前)
export const getWeekPerformanceTotal = (data?: any) => {
  return request.post({
    url: '/biz-adjust/week/weekPerformanceTotal',
    data
  })
}

// 删除产品单价配置
export const delProductPriceConfig = (data?: any) => {
  return request.post({
    url: '/productPriceConfig/delProductPriceConfig',
    data
  })
}

// 流向数量合计(折算前)
export const getFlowTrackTotal = (data?: any) => {
  return request.post({
    url: '/biz-adjust/flowTrackTotal',
    data
  })
}

// 任务完成调整-多组织 流向数量合计(折算前)
export const getPerformanceTotal = (data?: any) => {
  return request.post({
    url: '/biz-adjust/performanceTotal',
    data
  })
}

// 删除送达方拆分
export const deleteFlowTrackRecipient = (data?: any) => {
  return request.post({
    url: '/flowTrackRecipient/delete',
    data
  })
}

//获取枚举列表
export const getEnumList = (data?: any) => {
  return request.post({
    url: '/report/common/sysDictList',
    data
  })
}

//获取页面对应低代码tab数据
export const getPageLowCodeTabData = (data?: any) => {
  return request.post({
    url: '/cola/pageTableList',
    data
  })
}
